import { t as e } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { createElementBlock as t, openBlock as n } from "vue";
//#region components/dropdown/dropdown_separator.vue
var r = {
	compatConfig: { MODE: 3 },
	name: "DtDropdownSeparator"
}, i = {
	"aria-hidden": "true",
	class: "d-list-item-separator"
};
function a(e, r, a, o, s, c) {
	return n(), t("li", i);
}
var o = /* @__PURE__ */ e(r, [["render", a]]);
//#endregion
export { o as default };

//# sourceMappingURL=dropdown-separator.js.map